import { render, staticRenderFns } from "./FirstQuestion.vue?vue&type=template&id=7e63278c&"
import script from "./FirstQuestion.vue?vue&type=script&lang=js&"
export * from "./FirstQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FirstQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports